import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';

export function WorkerReportsRedirectContainer(): ReactElement {
  return <Redirect to="/dashboard" />;
}
